<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <section class="miniStack">
    <div class="grid grid-cols-2 gap-2">
      <div>
        <p>Positions (selected: {{ activeId }})</p>
        <PositionList
          :positions="positions"
          :activeId="activeId"
          @selected="onSelected"
          @reordered="onReordered"
        />
      </div>

      <div>
        <p>Files (selected: {{ fileActiveId }})</p>
        <FilesList
          :files="files"
          :activeId="fileActiveId"
          @selected="onFileSelected"
        />
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import FilesList from '@/components/elements/Positions/FilesList.vue';
import PositionList from '@/components/elements/Positions/PositionList.vue';
import type { CadFile } from '@cutr/constants/order';
import type { Position } from '@cutr/constants/position';
import { DESIGN_MATURITY_OPTIONS } from '@cutr/constants/position';
import { ref } from 'vue';

function makePosition(id: number, quantity: number) {
  const dm =
    DESIGN_MATURITY_OPTIONS[
      Math.floor(Math.random() * DESIGN_MATURITY_OPTIONS.length)
    ];

  return {
    id: String(id),
    name: `Position ${id}`,
    description: '',
    designMaturity: dm,
    quantity,
    sortOrder: id,
    thumbnails: {
      sm: `https://picsum.photos/seed/${id}/50`,
    } as Position['thumbnails'],
  } as Position;
}
const ftypes = ['cabinet', 'pdf', 'partslist', '3D'];

function makeFile(id: number) {
  const filetype = ftypes[Math.floor(Math.random() * ftypes.length)];

  return {
    id: String(id),
    name: `File ${id}`,
    filetype: filetype,
  } as CadFile;
}

const activeId = ref('2');
const positions = ref<Position[]>([
  makePosition(1, 1),
  makePosition(2, 3),
  makePosition(3, 2),
  makePosition(4, 5),
]);

function onSelected(position: Position) {
  activeId.value = position.id;
}

function onReordered(reordered: Position[]) {
  positions.value = reordered.map((position, index) => ({
    ...position,
    sortOrder: index + 1,
  }));
}

const fileActiveId = ref('none');
const files = ref<CadFile[]>([
  makeFile(1),
  makeFile(2),
  makeFile(3),
  makeFile(4),
]);

function onFileSelected(file: CadFile) {
  fileActiveId.value = file.id;
}
</script>
